export interface TranslationStrings {
  and: string;
  Back: string;
  "Click to Expand": string;
  "Click to Hide": string;
  "Click to Highlight": string;
  "Click to Show": string;
  "Click to Show All": string;
  Download: string;
  "Loading Visualization": string;
  more: string;
  "No Data Available": string;
  "Powered by D3plus": string;
  Share: string;
  "Shift+Click to Hide": string;
  "Shift+Click to Highlight": string;
  Total: string;
  Values: string;
}

const translateLocale: Record<string, TranslationStrings> = {
  "ar-SA": {
    and: "\u0648",
    Back: "\u0644\u0644\u062e\u0644\u0641",
    "Click to Expand":
      "\u0627\u0646\u0642\u0631 \u0644\u0644\u062a\u0648\u0633\u064a\u0639",
    "Click to Hide":
      "\u0627\u0636\u063a\u0637 \u0644\u0644\u0625\u062e\u0641\u0627\u0621",
    "Click to Highlight":
      "\u0627\u0636\u063a\u0637 \u0644\u0644\u062a\u062d\u062f\u064a\u062f",
    "Click to Show": "\u0627\u0646\u0642\u0631 \u0644\u0644\u0639\u0631\u0636",
    "Click to Show All":
      "\u0627\u0646\u0642\u0631 \u0644\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
    Download: "\u062a\u062d\u0645\u064a\u0644",
    "Loading Visualization":
      "\u062c\u0627\u0631\u064a \u062a\u062d\u0645\u064a\u0644 \u0627\u0644\u062a\u0635\u0648\u064a\u0631 \u0627\u0644\u0628\u064a\u0627\u0646\u064a",
    "No Data Available":
      "\u0644\u0627 \u062a\u062a\u0648\u0641\u0631 \u0628\u064a\u0627\u0646\u0627\u062a",
    more: "\u0623\u062e\u0631\u0649",
    "Powered by D3plus":
      "\u0645\u062f\u0639\u0648\u0645 \u0628\u0648\u0627\u0633\u0637\u0629 D3plus",
    Share: "\u0645\u0634\u0627\u0631\u0643\u0629",
    "Shift+Click to Hide":
      "Shift+\u0627\u0646\u0642\u0631 \u0644\u0644\u0625\u062e\u0641\u0627\u0621",
    "Shift+Click to Highlight":
      "Shift + \u0644\u0644\u062a\u062d\u062f\u064a\u062f \u0627\u0636\u063a\u0637",
    Total: "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    Values: "\u0627\u0644\u0642\u064a\u0645",
  },
  "es-ES": {
    and: "y",
    Back: "Atr\u00e1s",
    "Click to Expand": "Clic para Ampliar",
    "Click to Hide": "Clic para Ocultar",
    "Click to Highlight": "Clic para Resaltar",
    "Click to Show": "Clic para Mostrar",
    "Click to Show All": "Clic para Mostrar Todo",
    Download: "Descargar",
    "Loading Visualization": "Cargando Visualizaci\u00f3n",
    more: "m\u00e1s",
    "No Data Available": "Datos No Disponibles",
    "Powered by D3plus": "Funciona con D3plus",
    Share: "Porcentaje",
    "Shift+Click to Hide": "May\u00fas+Clic para Ocultar",
    "Shift+Click to Highlight": "May\u00fas+Clic para Resaltar",
    Total: "Total",
    Values: "Valores",
  },
  "pt-BR": {
    and: "e",
    Back: "Voltar",
    "Click to Expand": "Clique para Expandir",
    "Click to Hide": "Clique para Ocultar",
    "Click to Highlight": "Clique para Destacar",
    "Click to Show": "Clique para Mostrar",
    "Click to Show All": "Clique para Mostrar Tudo",
    Download: "Baixar",
    "Loading Visualization": "Carregando Visualiza\u00e7\u00e3o",
    more: "mais",
    "No Data Available": "Dados N\u00e3o Dispon\u00edveis",
    "Powered by D3plus": "Funciona com D3plus",
    Share: "Porcentagem",
    "Shift+Click to Hide": "Shift+Clique para Ocultar",
    "Shift+Click to Highlight": "Shift+Clique para Destacar",
    Total: "Total",
    Values: "Valores",
  },
  "zh-CN": {
    and: "\u548c",
    Back: "\u540e\u9762",
    "Click to Expand": "\u5355\u51fb\u5c55\u5f00",
    "Click to Hide": "\u5355\u51fb\u9690\u85cf",
    "Click to Highlight": "\u5355\u51fb\u7a81\u51fa\u663e\u793a",
    "Click to Show": "\u5355\u51fb\u663e\u793a",
    "Click to Show All": "\u5355\u51fb\u663e\u793a\u5168\u90e8",
    Download: "\u4e0b\u8f7d",
    "Loading Visualization": "\u52a0\u8f7d\u53ef\u89c6\u5316",
    more: "\u66f4\u591a",
    "No Data Available": "\u65e0\u53ef\u7528\u6570\u636e",
    "Powered by D3plus": "\u7531 D3plus \u63d0\u4f9b\u652f\u6301",
    Share: "\u5171\u4eab",
    "Shift+Click to Hide": "Shift+\u5355\u51fb\u9690\u85cf",
    "Shift+Click to Highlight": "Shift+\u5355\u51fb\u7a81\u51fa\u663e\u793a",
    Total: "\u603b",
    Values: "\u503c",
  },
};

export default translateLocale;
